exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".holder{position:relative}.date-controls{position:absolute;top:50%;right:5px;-webkit-transform:translateY(-50%);transform:translateY(-50%);z-index:99;font-size:16px}.date-controls span{padding:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-697d553d","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/admin/components/VDateFilter.vue
// module id = /TGL
// module chunks = 1 2